// @systeme: contrat
// « Ma semaine » (DEC-026) : un regard sur l'organisation, sur demande, jamais poussé.
// Des observations calculées par le serveur, factuelles, sur l'organisation et jamais sur
// la personne (produit §8), chacune avec, quand c'est possible, un geste à faire d'un
// clic. Aucun modèle de langage n'intervient : rien ne sort, rien ne dérape.
import { z } from 'zod';
import { SchemaInstant, SchemaJour } from './elements.js';
import { SchemaRegleRecurrence } from './recurrences.js';
import { SchemaOptionReport } from '../enumerations.js';
export const ClesObservation = [
    'journee_chargee',
    'preparation_serree',
    'toujours_reportee',
    'recurrence_ignoree',
    'sans_date',
    'respiration',
];
export const SchemaCleObservation = z.enum(ClesObservation);
/** Un geste proposé : il passe par les routes existantes (report, suppression, récurrence). */
export const SchemaActionCoaching = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('reporter'),
        libelle: z.string(),
        elementId: z.uuid(),
        quand: SchemaOptionReport,
        date: SchemaJour.optional(),
    }),
    z.object({ type: z.literal('supprimer'), libelle: z.string(), elementId: z.uuid() }),
    z.object({ type: z.literal('mettre_en_pause'), libelle: z.string(), recurrenceId: z.uuid() }),
    z.object({
        type: z.literal('changer_jours'),
        libelle: z.string(),
        recurrenceId: z.uuid(),
        regle: SchemaRegleRecurrence,
    }),
    z.object({
        type: z.literal('ouvrir'),
        libelle: z.string(),
        chemin: z.enum(['/', '/a-venir', '/a-venir/preparations', '/a-venir/recurrences']),
    }),
]);
export const SchemaObservation = z.object({
    cle: SchemaCleObservation,
    /** Le fait, en une ou deux phrases. Jamais un jugement. */
    texte: z.string(),
    actions: z.array(SchemaActionCoaching),
});
export const SchemaBilanSemaine = z.object({
    genereLe: SchemaInstant,
    /** La semaine regardée : de ce lundi au dimanche suivant. */
    semaineDebut: SchemaJour,
    semaineFin: SchemaJour,
    /** Ce qui a été fait sur les sept derniers jours. Un chiffre, pas une note. */
    faitesSeptJours: z.number().int(),
    observations: z.array(SchemaObservation),
});
//# sourceMappingURL=coaching.js.map